import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGetTotalNotificationAction } from '@/Module/Profile/Model/ApiModel';
import type { ITotalNotification } from '@/Module/Profile/Model/DataModel';
import NotificationService from '@/Module/Profile/Service/NotificationService';

export const getTotalNotificationAction = createAsyncThunk<ITotalNotification, IGetTotalNotificationAction>(
  'notification/getTotalNotificationAction',
  async (req, { signal }) => {
    return NotificationService.getTotalNotification(
      { TypeId: req.TypeId, CategoryId: req.CategoryId },
      signal,
      req.token,
    ).then(({ data: { data } }) => data);
  },
);
